module.exports = __webpack_public_path__ + "img/Url.b123a2bb.png";